import type { SxStyleFunc } from '@aibees/shared/theme';
import { Theme } from '@mui/material/styles';

export const paymentCard: SxStyleFunc<{
  inUse?: boolean;
  isDefault?: boolean;
}> = ({ inUse, isDefault }) => {
  const base = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: (p: Theme) => p.spacing(2),
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: (p: Theme) => p.spacing(0.5),
    padding: (p: Theme) => p.spacing(1, 1.5),
  };

  if (inUse) {
    return {
      ...base,
      ...{
        borderColor: (p) => p.palette.primary[500],
        background: (p) => p.palette.primary[50],
      },
    };
  }

  if (isDefault) {
    return {
      ...base,
      ...{
        borderColor: (p) => p.palette.success[500],
        background: (p) => p.palette.success[50],
      },
    };
  }

  return {
    ...base,
    ...{
      borderColor: (p) => p.palette.grey[300],
      background: (p) => p.palette.common.white,
    },
  };
};
